import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CREATE_STUDENT_FEEDBACK, CREATING_STUDENT_FEEDBACK, GET_STUDENT_FEEDBACK, GETTING_STUDENT_FEEDBACK, SET_SUCCESS, STUDENT_FEEDBACK_ERROR, UPDATE_STUDENT_FEEDBACK, UPDATING_STUDENT_FEEDBACK } from "../types"

export const createStudentFeedback = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_STUDENT_FEEDBACK,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/feedback`, payload, { headers })
        
        dispatch({
            type: CREATE_STUDENT_FEEDBACK,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Student feedback submitted successfully'
        })
        
    }
    catch(error){
        dispatch({
            type: STUDENT_FEEDBACK_ERROR,
            error
        })
    }
}

export const updateStudentFeedback = (id, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_STUDENT_FEEDBACK,
            payload: true
        })

        const response = await axios.patch(`${baseUrl}/feedback/${id}`, payload, { headers })
        
        dispatch({
            type: UPDATE_STUDENT_FEEDBACK,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: STUDENT_FEEDBACK_ERROR,
            error
        })
    }
}

export const fetchStudentFeedback = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/feedback?expand=createdBy`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_STUDENT_FEEDBACK,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_STUDENT_FEEDBACK,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: STUDENT_FEEDBACK_ERROR,
            error
        })
    }
}

export const clearCreatedStudentFeedback = () => async (dispatch) => {    
    dispatch({
        type: CREATE_STUDENT_FEEDBACK,
        payload: null
    })   
}

export const clearUpdatedStudentFeedback = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_STUDENT_FEEDBACK,
        payload: null
    })   
}